import { render } from "./ProjectPicker.vue?vue&type=template&id=0c5b13f1&ts=true"
import script from "./ProjectPicker.vue?vue&type=script&lang=ts"
export * from "./ProjectPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__